module.exports = __webpack_public_path__ + "static/media/img9.b75099b6.jpg";